interface IEnvironmentHazard {
  type: EnvironmentHazardType;
  allowUndockWithoutValidRoom: boolean;
  driveBackwardsEnabled: boolean;
  dropRescueEnabled: boolean;
  positionLostRescueEnabled: boolean;
}

export enum EnvironmentHazardType {
  NoHazard = "NoHazard",
  CriticalZones = "CriticalZones",
  FallingRisk = "FallingRisk",
}

export const DEFAULT_ENVIRONMENT_HAZARD_TYPE = EnvironmentHazardType.NoHazard;

export const getEnvironmentHazardTypes = Object.values(EnvironmentHazardType);
export const getGlobalEnvironmentHazardTypes = getEnvironmentHazardTypes.filter((t) => t != null);

export default IEnvironmentHazard;
